import React, { useEffect, useState } from "react";
//import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route, useHistory } from "react-router-dom";
import Relatorio from "./Component/Relatorio";
import Pagamento from "./Component/Pagamento";
import Conta from "./Component/Conta";
import Unidade from "./Component/Unidade";
import Conciliacao from "./Component/Conciliacao";
import PontoVenda from "./Component/PontoVenda";
import Informativo from "./Component/Informativo";
import Dash from "./Component/Dash";
import Notificacao from "./Component/Notificacao";
import Usuario from "./Component/Usuario";

import Menu from "./Component/Menu1";

import NewMenu from "./Component/menu";

import { Dropdown } from "react-bootstrap";

/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you require will output into a single css file (app.css in this case)
//require('../css/admin.scss');
//import 'bootstrap/dist/js/bootstrap';
//import logoCopyAdmin from '../img/logos-admin.svg';
//import $ from 'jquery';
import api from "../../services/api";
// Need jQuery? Install it with "yarn add jquery", then uncomment to require it.
// const $ = require('jquery');
import "./admin.css";
import Restricao from "./Component/Restricao";
import { Container } from "./style";
import styled from "styled-components";
import Dashboard from "./Component/dashboard";
import Transacoes from "./Component/transacoes";
import TransacoesPendentes from "./Component/transacoes/transacoesPendentes";
import Conciliacoes from "./Component/conciliacoes";
import LinksDePagamento from "./Component/linkPagamentos";

require("./admin.scss");

export default function Admin() {
  const [login, setLogin] = useState("");
  const [permissao, setPermissao] = useState(0);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  async function getUserData() {
    const userTemp = sessionStorage.getItem(
      `@${process.env.REACT_APP_ESTATE_ID}TEMP_MATRICULA_NAME`
    );
    if (userTemp) {
      setLogin(userTemp);
      setPermissao(-1);

      return;
    }
    //sessionStorage.setItem('@amEnergiaPigz-path', '/admin');
    setLoading(true);
    try {
      const resp = await api.get("/admin/json/userdata");
      //console.log(resp);
      const { login, permissao } = resp.data;
      //console.log(permissao)

      //console.log(login);
      //console.log(login);

      if (login) {
        setLogin(login);
        setPermissao(permissao);
        //console.log(permissao)
      } else {
        history.replace("/");
        setTimeout(function () {
          alert("Sessão Expirada");
        }, 1000);
      }
      setLoading(false);
    } catch (error) {
      history.replace("/");

      setTimeout(function () {
        alert("Sessão Expirada");
      }, 1000);

      setLoading(false);
    }
  }

  useEffect(() => {
    getUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function logout() {
    //return;

    const response = await api.get("/admin/logout");

    //console.log(response);

    if (response.status === 200) {
      history.replace("/");
    }
    history.replace("/");
  }
  //console.log(permissao)

  if (login === "") {
    return (
      <div className="container-fluid max-width-100">
        <BrowserRouter>
          <NewMenu loading={loading} permissao={permissao} />

          <div
            style={{
              height: "100vh",
              width: "100%",
              //background: '#000',
            }}
          >
            <div
              className="Skeleton"
              style={{
                width: "100%",
                height: "20vh",
                marginTop: "10vh",
                marginBottom: 20,
              }}
            ></div>
            <div
              className="Skeleton"
              style={{ width: "100%", height: "50vh" }}
            ></div>
          </div>
        </BrowserRouter>
      </div>
    );
  }

  if (login !== "") {
    return (
      <Container>
        <BrowserRouter>
          <NewMenu loading={loading} permissao={permissao} />

          <div style={{ paddingLeft: 0 }} className="col-md-10  pt-0">
            <div
              style={{ display: "none" }}
              className=" mb-2 float-right header-admin"
            >
              {loading ? (
                <div className="Skeleton" style={{ height: 36, width: 150 }} />
              ) : (
                <Dropdown className="dropdown">
                  <Dropdown.Toggle
                    style={{ background: "transparent", border: 0 }}
                    className="btn btn-clear dropdown-toggle"
                  >
                    Bem-vindo, <strong>{login}</strong>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu">
                    <Dropdown.Item
                      onClick={(e) => {
                        e.preventDefault();
                        logout();
                      }}
                      classname="dropdown-item btn btn-sm"
                    >
                      {"Sair"}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}

              {/*<div className='dropdown'>
								<button
									className='btn btn-clear dropdown-toggle'
									type='button'
									id='dropdownMenu2'
									data-toggle='dropdown'
									aria-haspopup='true'
									aria-expanded='false'>
									Bem-vindo, <strong>{login}</strong>
								</button>
								<div className='dropdown-menu' aria-labelledby='dropdownMenu2'>
									<a className='dropdown-item btn btn-sm' href='/admin/logout'>
										<span>Sair</span>
									</a>
								</div>
									</div>*/}
            </div>

            <RouteContainer>
              <Switch>
                {permissao !== -1 && (
                  <Route
                    path="/admin/transacoes"
                    exact={true}
                    component={Pagamento}
                  />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/transacao"
                    exact={true}
                    component={Relatorio}
                  />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/pendencias"
                    exact={true}
                    component={TransacoesPendentes}
                  />
                )}
                <Route path="/admin/link" exact component={LinksDePagamento} />
                {permissao === 2 && (
                  <Route path="/admin/conta" exact={true} component={Conta} />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/unidade"
                    exact={true}
                    component={Unidade}
                  />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/conciliacao"
                    exact={true}
                    component={Conciliacoes}
                  />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/pontovenda"
                    exact={true}
                    component={PontoVenda}
                  />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/notificacao"
                    exact={true}
                    component={Notificacao}
                  />
                )}
                {permissao === 2 && (
                  <Route
                    path="/admin/informativo"
                    exact={true}
                    component={Informativo}
                  />
                )}
                {permissao !== -1 && (
                  <Route
                    path="/admin/dash"
                    exact={true}
                    component={Dashboard}
                  />
                )}
                {permissao !== -1 && (
                  <Route path="/admin/dash1" exact={true} component={Dash} />
                )}
                {permissao !== -1 && (
                  <Route path="/admin" exact={true} component={Transacoes} />
                )}
                {permissao === 2 && (
                  <Route
                    path="/admin/usuario"
                    exact={true}
                    component={Usuario}
                  />
                )}
                {permissao === 2 && (
                  <Route
                    path="/admin/restricao"
                    exact={true}
                    component={Restricao}
                  />
                )}
              </Switch>
            </RouteContainer>
          </div>
        </BrowserRouter>
      </Container>
    );
  }

  /*return (
		<div className='container-fluid max-width-100'>
			<BrowserRouter>
				<div className='row'>
					<div className='col-md-2 p-0'>
						<div className='Sidebar position-fixed z-index-100'>
							<Menu loading={loading} permissao={permissao} />
						</div>
					</div>
					<div className='col-md-10  pt-0'>
						<div
							style={{ display: 'none' }}
							className=' mb-2 float-right header-admin'>
							{loading ? (
								<div className='Skeleton' style={{ height: 36, width: 150 }} />
							) : (
								<Dropdown className='dropdown'>
									<Dropdown.Toggle
										style={{ background: 'transparent', border: 0 }}
										className='btn btn-clear dropdown-toggle'>
										Bem-vindo, <strong>{login}</strong>
									</Dropdown.Toggle>
									<Dropdown.Menu className='dropdown-menu'>
										<Dropdown.Item
											onClick={(e) => {
												e.preventDefault();
												logout();
											}}
											classname='dropdown-item btn btn-sm'>
											{'Sair'}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							)}

							{<div className='dropdown'>
								<button
									className='btn btn-clear dropdown-toggle'
									type='button'
									id='dropdownMenu2'
									data-toggle='dropdown'
									aria-haspopup='true'
									aria-expanded='false'>
									Bem-vindo, <strong>{login}</strong>
								</button>
								<div className='dropdown-menu' aria-labelledby='dropdownMenu2'>
									<a className='dropdown-item btn btn-sm' href='/admin/logout'>
										<span>Sair</span>
									</a>
								</div>
									</div>}
						</div>

						<Switch>
							<Route path='/admin' exact={true} component={Pagamento} />
							<Route
								path='/admin/transacao'
								exact={true}
								component={Relatorio}
							/>
							{permissao === 2 && (
								<Route path='/admin/conta' exact={true} component={Conta} />
							)}
							<Route path='/admin/unidade' exact={true} component={Unidade} />
							<Route
								path='/admin/conciliacao'
								exact={true}
								component={Conciliacao}
							/>
							<Route
								path='/admin/pontovenda'
								exact={true}
								component={PontoVenda}
							/>
							<Route
								path='/admin/notificacao'
								exact={true}
								component={Notificacao}
							/>
							{permissao === 2 && (
								<Route
									path='/admin/informativo'
									exact={true}
									component={Informativo}
								/>
							)}
							<Route path='/admin/dash' exact={true} component={Dash} />
							{permissao === 2 && (
								<Route path='/admin/usuario' exact={true} component={Usuario} />
							)}
							{permissao === 2 && (
								<Route
									path='/admin/restricao'
									exact={true}
									component={Restricao}
								/>
							)}
						</Switch>
					</div>
				</div>
			</BrowserRouter>
		</div>
	);*/
}

const RouteContainer = styled.div`
  height: calc(100%);
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    background: transparent;

    // display:none;

    width: 0;
  }

  &::-webkit-scrollbar-track {
    /*  margin-top:0;
      border-bottom-right-radius: 16px;
      background-image: url("https://i.stack.imgur.com/Pwbuz.png");
    background-repeat: repeat-y;
    background-size: contain;
      */
    // margin-top: 54px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(103, 103, 103, 0.5);
    border-radius: 20px;
    border: 2.5px solid rgba(0, 0, 0, 0);
    border-right: 5px solid rgba(0, 0, 0, 0);

    background-clip: padding-box;
    max-height: 5px;
    transition: all 1s;
  }
`;
